<template>
  <EXDialog
    :title="title"
    @close="cancel"
    :showVisible="curShowDelete"
    class="deteleDialog"
  >
    <div class="deteleP">
      <div class="top-tip">
        <img class="tipimg" src="@/assets/images/delTip.png" alt="">
        <span class="content">{{content}}</span>
      </div>
      <div v-if="subContent" class="subContent">{{subContent}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure()">确 定</el-button>
        <el-button type="primary" plain @click="cancel()">取 消</el-button>
      </div>
    </div>
  </EXDialog>
</template>

<script>
import EXDialog from "./index.vue";
export default {
  name: 'EXConfirmDialog',
  props:{
    showDelete: Boolean,
    title:{
      type: String,
      default: '提示'
    },
    content:String,
    subContent:String,
    sureFn:Function,
    cancelFn:Function,
  },
  components: {
    EXDialog
  },
  computed:{
    curShowDelete:{
      get(){
        return this.showDelete
      }
    }
  },
  methods:{
    // 确定
    sure(){
      this.$emit('sureFn')
    },
    // 取消
    cancel(){
      this.$emit('cancelFn')
    },
  }
}
</script>

<style lang="scss" scoped>
.top-tip{
  display: flex;
  align-items: center;
  margin-bottom: .3rem;
}
.dialog-footer{
  text-align: center;
}
.tipimg{
  display: inline-block;
  width: .2rem;
  height: .2rem;
  margin-right: .1rem;
}
.content{
  font-size: .16rem;
  // font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333;
}
.subContent{
  margin-left: .3rem;
  margin-top: 0;
  font-size: .14rem;
  // font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  margin-bottom: .3rem;
}
/deep/ .el-button{
  min-width: 0.8rem;
  height: 0.36rem;
  margin: 0 0.05rem;
  padding: 0.1rem;
  font-size: .16rem;
}
/deep/ .el-dialog{
  width:4rem;
  min-width:3.6rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  margin-top: 0 !important; // 覆盖15vh
}
</style>


// WEBPACK FOOTER //
// src/components/EXDialog/EXConfirmDialog.vue